<template>
	<div class="partial-container partial-sidebar">

		<!-- netcallAppSwitcher -->
		<router-link class="netcallAppSwitcher" to="/" title="Dashboard">
			<a class="netcallIcon"></a>
		</router-link>

		<!-- Navigation -->
		<nav id="navigation" class="navigation minified-sidebar">
			<div class="nav-section-top">

				<router-link v-if="hasAccess('create') && isCreateActive" :class="{'router-link-active' : (whichSection === 'create')}" class="navigation-item Create" to="/create/applications" title="Create">
					<span></span>

					<ul v-if="hasAccess('create') && isCreateActive" class="nav-dropdown-items" role="menu">
						<!-- Section: Create -->
						<div class="navigation-item nav-header" @click="$event.preventDefault();">
							<p class="text">
								CREATE
							</p>
						</div>

						<router-link class="navigation-item" to="/create/applications" title="Create: Applications">
							<p class="text">
								Applications
							</p>

						</router-link>

						<router-link class="navigation-item" to="/create/environments" title="Create: Environments">
							<p class="text">
								Environments
							</p>

						</router-link>

						<template v-if="!isMultiTenantController">
							<router-link v-if="hasAccess('admin')" class="navigation-item" to="/create/resources" title="Create: Resources">
								<p class="text">
									Resources
								</p>

							</router-link>
						</template>
					</ul>

				</router-link>

				<router-link v-if="hasAccess('rpa') && isRpaActive" :class="{'router-link-active' : (whichSection === 'rpa')}" class="navigation-item RPA" to="/rpa/flows" title="RPA">
					<span></span>

					<ul v-if="hasAccess('rpa') && isRpaActive" class="nav-dropdown-items" role="menu">
						<!-- Section: RPA -->
						<div class="navigation-item nav-header" @click="$event.preventDefault();">
							<p class="text">
								RPA
							</p>
						</div>

						<router-link class="navigation-item" to="/rpa/flows" title="RPA: Flows">
							<p class="text">
								Flows
							</p>
						</router-link>

						<router-link class="navigation-item" to="/rpa/jobs" title="RPA: Jobs">
							<p class="text">
								Jobs
							</p>
						</router-link>

						<router-link class="navigation-item" to="/rpa/bots" title="RPA: Bots">
							<p class="text">
								Bots
							</p>
						</router-link>

						<router-link class="navigation-item" to="/rpa/credentials" title="RPA: Credentials">
							<p class="text">
								Credentials
							</p>
						</router-link>

						<a class="navigation-item" href="#" title="RPA: Download RPA Studio" @click="openDownloadModal()">
							<p class="text">Download RPA Studio</p>
						</a>
					</ul>

				</router-link>

				<router-link v-if="hasAccess('ai')" :class="{'router-link-active' : (whichSection === 'ai')}" class="navigation-item AI" to="/ai/models" title="AI">
					<span></span>

					<ul v-if="hasAccess('ai')" class="nav-dropdown-items" role="menu">
						<!-- Section: AI -->
						<div class="navigation-item nav-header" @click="$event.preventDefault();">
							<p class="text">
								AI
							</p>
						</div>

						<router-link class="navigation-item" to="/ai/models" title="AI: Models">
							<p class="text">
								Models
							</p>
						</router-link>

						<router-link class="navigation-item" to="/ai/knowledge-management/local/collections" title="AI: Knowledge Management">
							<p class="text">
								Knowledge Management
							</p>
						</router-link>
					</ul>

				</router-link>

				<router-link v-if="hasAccess('converse') && isConverseActive" :class="{'router-link-active' : (whichSection === 'converse')}" class="navigation-item Converse" to="/converse-cx/dashboard" title="Converse CX">
					<span></span>

					<ul v-if="hasAccess('converse') && isConverseActive" class="nav-dropdown-items" role="menu">
						<!-- Section: Converse CX -->
						<div class="navigation-item nav-header" @click="$event.preventDefault();">
							<p class="text">
								CONVERSE CX
							</p>
						</div>

						<router-link class="navigation-item" to="/converse-cx/dashboard" title="Converse CX: Dashboard">
							<p class="text">
								Dashboard
							</p>
						</router-link>
					</ul>
				</router-link>

				<router-link v-if="hasAccess('spark') && isSparkActive && isSparkAccountCreated" :class="{'router-link-active' : (whichSection === 'spark')}" class="navigation-item Spark" to="/spark/dashboard" title="Spark">
					<span></span>

					<ul v-if="hasAccess('spark') && isSparkActive && isSparkAccountCreated" class="nav-dropdown-items" role="menu">
						<!-- Section: Spark -->
						<div class="navigation-item nav-header" @click="$event.preventDefault();">
							<p class="text">
								SPARK
							</p>
						</div>

						<router-link class="navigation-item" to="/spark/dashboard" title="Spark: Dashboard">
							<p class="text">
								Dashboard
							</p>
						</router-link>
					</ul>
				</router-link>

				<router-link v-if="hasAccess('idp') && isIdpActive" :class="{'router-link-active' : (whichSection === 'idp')}" class="navigation-item IDP" to="/idp/document-types" title="IDP">
					<span></span>

					<ul v-if="hasAccess('idp') && isIdpActive" class="nav-dropdown-items" role="menu">
						<!-- Section: IDP -->
						<div class="navigation-item nav-header" @click="$event.preventDefault();">
							<p class="text">
								IDP
							</p>
						</div>

						<router-link class="navigation-item" to="/idp/document-types" title="IDP: Documents">
							<p class="text">
								Document Types
							</p>
						</router-link>
						<router-link class="navigation-item" to="/idp/bundles" title="IDP: Bundles">
							<p class="text">
								Bundles
							</p>
						</router-link>
						<router-link class="navigation-item" to="/idp/api-and-ui-access" title="IDP: API and UI Access">
							<p class="text">
								API and UI Access
							</p>
						</router-link>
					</ul>
				</router-link>

			</div>

			<!-- Section: Admin -->
			<div v-if="hasAccess('admin') || hasAccess('reporting')" class="nav-section-bottom">
				<router-link v-if="isUserSessions || isAiUnitActive || isIdpActive" class="navigation-item" to="/licensing" title="Licensing">
					<span><fa class="icon" :icon="['far', 'id-badge']" /></span>
				</router-link>
				<template v-if="!isMultiTenantController">
					<router-link class="navigation-item" to="/reports" title="Reports" :class="{'router-link-active' : (whichSection === 'reports')}">
						<span><fa class="icon" :icon="['far', 'chart-bar']" /></span>
					</router-link>
				</template>
				<router-link class="navigation-item" to="/users" title="Users" :class="{'router-link-active' : (whichSection === 'users')}">
					<span><fa class="icon" :icon="['far', 'users']" /></span>
				</router-link>

				<router-link v-if="hasAccess('admin')" class="navigation-item" to="/settings" title="Settings">
					<span><fa class="icon" :icon="['far', 'cog']" /></span>
				</router-link>

				<router-link class="navigation-item" to="/audit" title="Audit">
					<span><fa class="icon" :icon="['far', 'list-alt']" /></span>
				</router-link>

				<router-link class="navigation-item" to="/about" title="About">
					<span><fa class="icon" :icon="['far', 'info-circle']" /></span>
				</router-link>
			</div>
		</nav>

		<download-rpa-studio
			v-if="hasAccess('rpa') && isRpaActive"
			:active="show_modal"
			:active_bot="active_bot"
			:from_sidebar="true"
			@close-download-modal="closeDownloadModal"
		/>

	</div>
</template>

<script lang="ts">
	import { Options, Vue } from 'vue-class-component';
	import DownloadRpaStudio from '../components/DownloadRpaStudio.vue';

	@Options({
		name: 'Sidebar',
		components: { DownloadRpaStudio },
	})
	export default class SidebarPartial extends Vue {

		public show_modal = false;
		public active_bot: null|Record<string, any> = null;

		public get whichSection() : string {
			if (/^\/$/.test(this.$route.path)) {
				return 'dashboard';
			} else if (this.$route.path.startsWith('/create/')) {
				return 'create';
			} else if (this.$route.path.startsWith('/rpa/')) {
				return 'rpa';
			} else if (this.$route.path.startsWith('/ai/')) {
				return 'ai';
			} else if (this.$route.path.startsWith('/spark/')) {
				return 'spark';
			} else if (this.$route.path.startsWith('/idp/')) {
				return 'idp';
			} else if (this.$route.path.startsWith('/converse-cx/')) {
				return 'converse';
			} else if (this.$route.path.startsWith('/reports/')) {
				return 'reports';
			} else if (this.$route.path.startsWith('/users/')) {
				return 'users';
			}

			return 'controller';
		}

		public get isUserSessions(): boolean {
			return this.$store.state.configuration.licenceModel === 'User Sessions';
		}

		public get isAdmin(): boolean {
			return this.$store.state.account.isAdmin;
		}

		public get hasBots(): boolean {
			return (this.$store.state.configuration.licensedAttendedBots + this.$store.state.configuration.licensedUnattendedBots + this.$store.state.configuration.licensedDeveloperBots) > 0;
		}

		public get isRpaActive(): boolean {
			return this.$store.state.configuration.isRpaActive;
		}

		public get isCreateActive(): boolean {
			return this.$store.state.configuration.isCreateActive;
		}

		public get isAiActive(): boolean {
			return this.$store.state.configuration.isAiActive;
		}

		public get isConverseActive(): boolean {
			return this.$store.state.configuration.isConverseActive && this.$store.state.configuration.isConverseAccountCreated;
		}

		public get isSparkActive(): boolean {
			return this.$store.state.configuration.isSparkActive;
		}

		public get isSparkAccountCreated(): boolean {
			return this.$store.state.configuration.isSparkAccountCreated;
		}

		public get isIdpActive(): boolean {
			return this.$store.state.configuration.isIdpActive;
		}

		public get isMultiTenantController(): boolean {
			return this.$store.state.configuration.isMultiTenantController;
		}

		public get canCreateDevelopmentBots(): boolean {
			return this.$store.state.configuration.totalDeveloperBots < this.$store.state.configuration.licensedDeveloperBots;
		}

		public get isAiUnitActive(): boolean {
			return this.$store.state.configuration.isAiUnitActive;
		}

		public hasAccess(check: string): boolean {
			if (!this.$store.state.account.isLoggedIn) return false;
			if (check === 'reporting') return (this.$store.state.account.isReportingUser || this.$store.state.account.isAdmin) || false;
			if (check === 'admin') return this.$store.state.account.isAdmin || false;
			if (check === 'create') return (this.$store.state.account.isCreateUser || this.$store.state.account.isAdmin) || false;
			if (check === 'rpa') return (this.hasBots && (this.$store.state.account.isRpaUser || this.$store.state.account.isAdmin)) || false;
			if (check === 'ai') return (this.$store.state.account.isAiUser || this.$store.state.account.isAdmin) || false;
			if (check === 'converse') return (this.$store.state.account.isConverseCxUser || this.$store.state.account.isAdmin) || false;
			if (check === 'spark') return (this.$store.state.account.isSparkUser || this.$store.state.account.isAdmin) || false;
			if (check === 'idp') return (this.$store.state.account.isIdpUser || this.$store.state.account.isAdmin) || false;
			return false;
		}

		public openDownloadModal(): void {
			this.active_bot = {};
			this.show_modal = true;
		}

		public closeDownloadModal(): void {
			this.show_modal = false;
			this.active_bot = null;
		}

		public elClick(e: Event) : string {
			e.preventDefault();
			return '';
		}
	}
</script>

<style lang="scss" scoped>
	@import '../assets/styles/base';
	@import '../assets/styles/partials/sidebar';

	$sidebar-background:      #4863F0;
	$outlinecolour:           #dfe4e8;
	$formbackground:          #F9F9F9;
	$formdisabled:            #c2cfd6;
	$buttonprimarycolor:      $sidebar-background;
	$borderradius:            5px;
	$formborderradius:        $borderradius;
	$sidebarwidth:            56px;
	$topbarheight:            56px;

	.sidebar {
		&.create {
			.netcallAppSwitcher {
					background-color: $sidebar-create-color;
			}
		}
		&.rpa {
			.netcallAppSwitcher {
					background-color: $sidebar-RPA-color;
			}
		}
		&.ai {
			.netcallAppSwitcher {
					background-color: $sidebar-AI-color;
			}
		}
		&.converse {
			.netcallAppSwitcher {
					background-color: $sidebar-converse-color;
			}
		}
		&.spark {
			.netcallAppSwitcher {
				background-color: $sidebar-spark-color;
			}
		}
		&.idp {
			.netcallAppSwitcher {
				background-color: $sidebar-idp-color;
			}
		}
	}

	.netcallAppSwitcher {
		width: $sidebarwidth;
		height: $topbarheight;
		background-color: $sidebar-controller-color;
		display: flex;
		justify-content: center;
		align-items: center;
		.netcallIcon {
			background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 52.9 68.83'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fff;%7D%3C/style%3E%3C/defs%3E%3Cpath class='cls-1' d='M34.27,21.39L7.45,.95c-.82-.63-1.81-.95-2.81-.95-.7,0-1.4,.16-2.06,.48C1,1.26,0,2.87,0,4.64v59.56c0,2.56,2.08,4.64,4.64,4.64s4.64-2.08,4.64-4.64V14l25,19.06v-11.66Z'/%3E%3Cpath class='cls-1' d='M18.63,47.44l26.82,20.45c.82,.63,1.81,.95,2.81,.95,.7,0,1.4-.16,2.06-.48,1.58-.78,2.58-2.39,2.58-4.16V4.64C52.9,2.08,50.82,0,48.26,0s-4.64,2.08-4.64,4.64V54.83s-25-19.06-25-19.06v11.66Z'/%3E%3C/svg%3E");
			display: block;
			width: 30px;
			height: 30px;
			background-repeat: no-repeat;
			background-size: 50%;
			border-radius: $formborderradius;
			background-origin: border-box;
			background-position: center;
		}
		.netcallDropdown {
			display: none;
			position: absolute;
			top: 50px;
			left: 15px;
			width: 225px;
			height: fit-content;
			background: rgba(255, 255, 255, 0.95);
			border-radius: 5px 10px 10px 10px;
			padding: 1rem;
			box-shadow: 0px 3px 5px rgba($sidebar-background, 0.3);
			.netcallProducts {
				padding-left: 0;
		.navigation-item {
			&:last-of-type .netcallProduct {
			margin-bottom: 0;
			}
		}
				.netcallProduct {
					list-style: none;
					margin-bottom: 0.9rem;
					width: 100%;
					height: 30px;
					border-radius: 4px;
					padding: 3px 5px;
					transition: .5s ease-in-out background-color;
					background-position: left;
					background-repeat: no-repeat;
					background-size: 100%;
					&:hover {
						background-color: rgba($outlinecolour, 0.5);
						transition: .2s ease-in-out background-color;
					}
					&.Controller {
						background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 428 65'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:none;%7D.cls-2%7Bfill:%23f66;%7D.cls-3%7Bfill:%23062b80;%7D%3C/style%3E%3C/defs%3E%3Crect class='cls-1' width='428' height='65'/%3E%3Cg%3E%3Cpath class='cls-3' d='M89.75,19.92h5.35v20.4h10.71v4.92h-16.06V19.92Z'/%3E%3Cpath class='cls-3' d='M108.41,17.85h5.25v5.06h-5.25v-5.06Zm.07,8.21h5.17v19.17h-5.17V26.07Z'/%3E%3Cpath class='cls-3' d='M122.08,43.54h-.07v1.7h-4.78V18.83h5.17v8.39h.07c1.19-1.12,2.89-1.7,4.88-1.7,4.99,0,8.58,4.23,8.58,10.13s-3.58,10.13-8.58,10.13c-2.28,0-4.23-.98-5.28-2.24Zm8.68-7.89c0-3.44-1.56-5.39-4.38-5.39-2.32,0-3.98,1.66-3.98,4.02v2.75c0,2.32,1.66,4.02,3.98,4.02,2.79,0,4.38-1.99,4.38-5.39Z'/%3E%3Cpath class='cls-3' d='M138.03,35.65c0-5.97,3.73-10.13,9.04-10.13s9.01,4.09,9.01,10.13v1.52h-12.84c.14,2.71,1.59,4.27,3.94,4.27,1.88,0,3.29-.9,4.63-2.86l3.65,2.86c-1.84,2.89-4.67,4.34-8.29,4.34-5.43,0-9.15-4.05-9.15-10.13Zm13.02-2.13c-.18-2.32-1.59-3.65-3.94-3.65-2.13,0-3.69,1.45-3.87,3.65h7.81Z'/%3E%3Cpath class='cls-3' d='M158.94,26.07h4.85v1.7h.07c.83-1.27,2.24-2.06,4.12-2.06,.94,0,1.74,.11,2.5,.33l-.87,4.92c-.83-.22-1.45-.29-2.13-.29-2.21,0-3.36,1.48-3.36,4.27v10.31h-5.17V26.07Z'/%3E%3Cpath class='cls-3' d='M179.7,30.62v8.1c0,1.19,.43,1.56,1.95,1.56h2.1v4.96h-2.6c-4.74,0-6.62-1.74-6.62-6.19v-8.43h-3.29v-4.56h3.29v-4.81h5.17v4.81h4.74v4.56h-4.74Z'/%3E%3Cpath class='cls-3' d='M192.51,44.26l-7.38-18.2h5.35l4.59,12.16h.07l4.63-12.16h5.32l-11.03,27.31h-5.32l3.76-9.12Z'/%3E%3Cpath class='cls-3' d='M214.64,32.58c0-8,4.38-13.21,11.18-13.21,5.43,0,9.48,3.65,10.09,9.04l-5.25,.87c-.54-3.22-2.28-5.03-4.85-5.03-3.65,0-5.83,3.11-5.83,8.32s2.17,8.32,5.83,8.32c2.68,0,4.41-1.88,4.92-5.43l5.25,.9c-.65,5.72-4.63,9.41-10.17,9.41-6.8,0-11.18-5.21-11.18-13.21Z'/%3E%3Cpath class='cls-3' d='M237.68,35.65c0-6.04,3.87-10.13,9.48-10.13s9.51,4.09,9.51,10.13-3.87,10.13-9.51,10.13-9.48-4.09-9.48-10.13Zm13.82,0c0-3.44-1.59-5.43-4.34-5.43s-4.31,1.99-4.31,5.43,1.59,5.43,4.31,5.43,4.34-1.99,4.34-5.43Z'/%3E%3Cpath class='cls-3' d='M259.53,26.07h4.92v1.7h.07c1.12-1.38,3.15-2.24,5.28-2.24,4.2,0,7.02,2.89,7.02,7.45v12.26h-5.17v-11.36c0-2.28-1.23-3.58-3.47-3.58s-3.47,1.38-3.47,3.58v11.36h-5.17V26.07Z'/%3E%3Cpath class='cls-3' d='M286.73,30.62v8.1c0,1.19,.43,1.56,1.95,1.56h2.1v4.96h-2.6c-4.74,0-6.62-1.74-6.62-6.19v-8.43h-3.29v-4.56h3.29v-4.81h5.17v4.81h4.74v4.56h-4.74Z'/%3E%3Cpath class='cls-3' d='M293.97,26.07h4.85v1.7h.07c.83-1.27,2.24-2.06,4.12-2.06,.94,0,1.74,.11,2.5,.33l-.87,4.92c-.83-.22-1.45-.29-2.13-.29-2.21,0-3.36,1.48-3.36,4.27v10.31h-5.17V26.07Z'/%3E%3Cpath class='cls-3' d='M305.69,35.65c0-6.04,3.87-10.13,9.48-10.13s9.51,4.09,9.51,10.13-3.87,10.13-9.51,10.13-9.48-4.09-9.48-10.13Zm13.82,0c0-3.44-1.59-5.43-4.34-5.43s-4.31,1.99-4.31,5.43,1.59,5.43,4.31,5.43,4.34-1.99,4.34-5.43Z'/%3E%3Cpath class='cls-3' d='M327.53,18.83h5.17v26.41h-5.17V18.83Z'/%3E%3Cpath class='cls-3' d='M336.29,18.83h5.17v26.41h-5.17V18.83Z'/%3E%3Cpath class='cls-3' d='M344.28,35.65c0-5.97,3.73-10.13,9.04-10.13s9.01,4.09,9.01,10.13v1.52h-12.84c.14,2.71,1.59,4.27,3.94,4.27,1.88,0,3.29-.9,4.63-2.86l3.65,2.86c-1.84,2.89-4.67,4.34-8.29,4.34-5.43,0-9.15-4.05-9.15-10.13Zm13.02-2.13c-.18-2.32-1.59-3.65-3.94-3.65-2.13,0-3.69,1.45-3.87,3.65h7.81Z'/%3E%3Cpath class='cls-3' d='M365.19,26.07h4.85v1.7h.07c.83-1.27,2.24-2.06,4.12-2.06,.94,0,1.74,.11,2.5,.33l-.87,4.92c-.83-.22-1.45-.29-2.13-.29-2.21,0-3.36,1.48-3.36,4.27v10.31h-5.17V26.07Z'/%3E%3C/g%3E%3Cpath id='Path_39' class='cls-3' d='M44.49,17.79l15.78,12.07c1.22,.96,2.99,.75,3.96-.48,.96-1.22,.75-2.99-.48-3.96-.02-.02-.04-.03-.06-.04l-15.78-12.07c-1.25-.93-3.01-.67-3.94,.58-.91,1.23-.68,2.95,.52,3.9'/%3E%3Cpath id='Path_40' class='cls-2' d='M35.26,47.9l-15.78-12.07c-1.25-.93-3.01-.67-3.94,.58-.91,1.23-.68,2.95,.52,3.9l15.78,12.07c1.22,.96,2.99,.75,3.96-.48s.75-2.99-.48-3.96c-.02-.02-.04-.03-.06-.04'/%3E%3Cpath id='Path_41' class='cls-3' d='M64.92,48.6L18.69,13.25c-1.25-.93-3.01-.67-3.94,.58-.91,1.23-.68,2.95,.52,3.9L61.5,53.07c1.25,.93,3.01,.67,3.94-.58,.91-1.23,.68-2.95-.52-3.9'/%3E%3C/svg%3E");
					}
					&.Create {
						background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 428 65'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:none;%7D.cls-2%7Bfill:%23f66;%7D.cls-3%7Bfill:%23062b80;%7D%3C/style%3E%3C/defs%3E%3Crect class='cls-1' width='428' height='65'/%3E%3Cg%3E%3Cpath class='cls-3' d='M88.3,32.58c0-8,4.38-13.21,11.18-13.21,5.43,0,9.48,3.65,10.09,9.04l-5.25,.87c-.54-3.22-2.28-5.03-4.85-5.03-3.65,0-5.83,3.11-5.83,8.32s2.17,8.32,5.83,8.32c2.68,0,4.41-1.88,4.92-5.43l5.25,.9c-.65,5.72-4.63,9.41-10.17,9.41-6.8,0-11.18-5.21-11.18-13.21Z'/%3E%3Cpath class='cls-3' d='M112.1,26.07h4.85v1.7h.07c.83-1.27,2.24-2.06,4.12-2.06,.94,0,1.74,.11,2.5,.33l-.87,4.92c-.83-.22-1.45-.29-2.13-.29-2.21,0-3.36,1.48-3.36,4.27v10.31h-5.17V26.07Z'/%3E%3Cpath class='cls-3' d='M123.82,35.65c0-5.97,3.73-10.13,9.04-10.13s9.01,4.09,9.01,10.13v1.52h-12.84c.14,2.71,1.59,4.27,3.94,4.27,1.88,0,3.29-.9,4.63-2.86l3.65,2.86c-1.84,2.89-4.67,4.34-8.29,4.34-5.43,0-9.15-4.05-9.15-10.13Zm13.02-2.13c-.18-2.32-1.59-3.65-3.94-3.65-2.13,0-3.69,1.45-3.87,3.65h7.81Z'/%3E%3Cpath class='cls-3' d='M143.82,40.03c0-3.22,1.92-4.96,6.84-6.15,3.04-.72,3.98-1.27,3.98-2.28,0-1.12-.98-1.77-2.64-1.77-1.99,0-3.29,1.12-3.65,3.08l-4.74-1.05c.58-3.8,3.98-6.33,8.39-6.33,4.81,0,7.85,2.79,7.85,7.27v12.45h-4.63v-1.52h-.07c-.94,1.34-2.71,2.06-5.03,2.06-3.8,0-6.29-2.28-6.29-5.75Zm11-1.27v-2.79h-.07c-.33,.58-1.12,1.01-2.86,1.52-2.32,.62-3.11,1.19-3.11,2.21,0,1.16,.8,1.74,2.35,1.74,2.17,0,3.69-1.09,3.69-2.68Z'/%3E%3Cpath class='cls-3' d='M169.72,30.62v8.1c0,1.19,.43,1.56,1.95,1.56h2.1v4.96h-2.6c-4.74,0-6.62-1.74-6.62-6.19v-8.43h-3.29v-4.56h3.29v-4.81h5.17v4.81h4.74v4.56h-4.74Z'/%3E%3Cpath class='cls-3' d='M175.51,35.65c0-5.97,3.73-10.13,9.04-10.13s9.01,4.09,9.01,10.13v1.52h-12.84c.14,2.71,1.59,4.27,3.94,4.27,1.88,0,3.29-.9,4.63-2.86l3.65,2.86c-1.84,2.89-4.67,4.34-8.29,4.34-5.43,0-9.15-4.05-9.15-10.13Zm13.02-2.13c-.18-2.32-1.59-3.65-3.94-3.65-2.13,0-3.69,1.45-3.87,3.65h7.81Z'/%3E%3C/g%3E%3Crect class='cls-2' x='28.06' y='20.94' width='24.07' height='24.07'/%3E%3Cpath class='cls-3' d='M41.43,53.17H19.03V31.69h19.82V12.78h22.3v21.49h-19.72v18.91Zm-19.82-2.58h17.24v-16.33H21.61v16.33Zm19.82-18.91h17.14V15.36h-17.14V31.69Z'/%3E%3C/svg%3E");
					}
					&.Converse {
						background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 428 65'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:none;%7D.cls-2%7Bfill:%23f66;%7D.cls-3%7Bfill:%23062b80;%7D%3C/style%3E%3C/defs%3E%3Crect class='cls-1' width='428' height='65'/%3E%3Cg%3E%3Cpath class='cls-3' d='M88.3,32.58c0-8,4.38-13.21,11.18-13.21,5.43,0,9.48,3.65,10.09,9.04l-5.25,.87c-.54-3.22-2.28-5.03-4.85-5.03-3.65,0-5.83,3.11-5.83,8.32s2.17,8.32,5.83,8.32c2.68,0,4.41-1.88,4.92-5.43l5.25,.9c-.65,5.72-4.63,9.41-10.17,9.41-6.8,0-11.18-5.21-11.18-13.21Z'/%3E%3Cpath class='cls-3' d='M111.34,35.65c0-6.04,3.87-10.13,9.48-10.13s9.51,4.09,9.51,10.13-3.87,10.13-9.51,10.13-9.48-4.09-9.48-10.13Zm13.82,0c0-3.44-1.59-5.43-4.34-5.43s-4.31,1.99-4.31,5.43,1.59,5.43,4.31,5.43,4.34-1.99,4.34-5.43Z'/%3E%3Cpath class='cls-3' d='M133.19,26.07h4.92v1.7h.07c1.12-1.38,3.15-2.24,5.28-2.24,4.2,0,7.02,2.89,7.02,7.45v12.26h-5.17v-11.36c0-2.28-1.23-3.58-3.47-3.58s-3.47,1.38-3.47,3.58v11.36h-5.17V26.07Z'/%3E%3Cpath class='cls-3' d='M150.66,26.07h5.5l4.85,12.41h.07l4.85-12.41h5.5l-8,19.17h-4.78l-8-19.17Z'/%3E%3Cpath class='cls-3' d='M171.42,35.65c0-5.97,3.73-10.13,9.04-10.13s9.01,4.09,9.01,10.13v1.52h-12.84c.14,2.71,1.59,4.27,3.94,4.27,1.88,0,3.29-.9,4.63-2.86l3.65,2.86c-1.84,2.89-4.67,4.34-8.29,4.34-5.43,0-9.15-4.05-9.15-10.13Zm13.02-2.13c-.18-2.32-1.59-3.65-3.94-3.65-2.13,0-3.69,1.45-3.87,3.65h7.81Z'/%3E%3Cpath class='cls-3' d='M192.33,26.07h4.85v1.7h.07c.83-1.27,2.24-2.06,4.12-2.06,.94,0,1.74,.11,2.5,.33l-.87,4.92c-.83-.22-1.45-.29-2.13-.29-2.21,0-3.36,1.48-3.36,4.27v10.31h-5.17V26.07Z'/%3E%3Cpath class='cls-3' d='M203.69,39.05l4.59-1.23c.62,2.57,1.92,3.73,4.38,3.73,1.81,0,2.89-.58,2.89-1.56,0-1.52-1.88-2.06-4.16-2.79-3.26-.9-6.69-2.03-6.69-5.9,0-3.29,3.08-5.79,7.24-5.79,3.87,0,7.2,2.24,8.1,5.64l-4.56,1.34c-.65-1.88-1.92-2.79-3.54-2.79-1.52,0-2.42,.65-2.42,1.52,0,.98,1.45,1.37,3.44,1.95,3.33,.94,7.42,2.17,7.42,6.62,0,3.58-3.04,5.97-7.71,5.97s-8.14-2.39-8.97-6.73Z'/%3E%3Cpath class='cls-3' d='M222.1,35.65c0-5.97,3.73-10.13,9.04-10.13s9.01,4.09,9.01,10.13v1.52h-12.84c.14,2.71,1.59,4.27,3.94,4.27,1.88,0,3.29-.9,4.63-2.86l3.65,2.86c-1.84,2.89-4.67,4.34-8.29,4.34-5.43,0-9.15-4.05-9.15-10.13Zm13.02-2.13c-.18-2.32-1.59-3.65-3.94-3.65-2.13,0-3.69,1.45-3.87,3.65h7.81Z'/%3E%3Cpath class='cls-3' d='M250.74,32.58c0-8,4.38-13.21,11.18-13.21,5.43,0,9.48,3.65,10.09,9.04l-5.25,.87c-.54-3.22-2.28-5.03-4.85-5.03-3.65,0-5.83,3.11-5.83,8.32s2.17,8.32,5.83,8.32c2.68,0,4.41-1.88,4.92-5.43l5.25,.9c-.65,5.72-4.63,9.41-10.17,9.41-6.8,0-11.18-5.21-11.18-13.21Z'/%3E%3Cpath class='cls-3' d='M279.28,32.4l-7.78-12.48h6.01l4.81,8.54h.07l4.85-8.54h6l-7.78,12.48,8,12.84h-6.04l-5.03-8.94h-.07l-5.03,8.94h-6.01l8-12.84Z'/%3E%3C/g%3E%3Cg%3E%3Cpath class='cls-3' d='M39.97,14.89c9.42,0,17.16,7.28,17.92,16.5h2.5c-.77-10.6-9.63-19-20.42-19s-19.65,8.4-20.42,19h2.5c.77-9.22,8.51-16.5,17.92-16.5Z'/%3E%3Cpath class='cls-2' d='M57.9,34.39H19.55c.77,10.6,9.63,19,20.42,19s19.65-8.4,20.42-19h-2.5Z'/%3E%3C/g%3E%3Crect class='cls-3' x='38.68' y='23.53' width='2.58' height='18.72' rx='1.29' ry='1.29'/%3E%3C/svg%3E");
					}
					&.RPA {
						background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 428 65'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:none;%7D.cls-2%7Bfill:%23f66;%7D.cls-3%7Bfill:%23062b80;%7D%3C/style%3E%3C/defs%3E%3Crect class='cls-1' width='428' height='65'/%3E%3Cg%3E%3Cpath class='cls-3' d='M108.89,45.24h-5.75l-4.78-8.9h-3.26v8.9h-5.35V19.92h10.31c5.35,0,8.65,3.11,8.65,8.18,0,3.69-1.85,6.44-4.96,7.63v.04l5.14,9.48Zm-9.48-13.78c2.57,0,3.94-1.19,3.94-3.4s-1.34-3.26-3.94-3.26h-4.31v6.66h4.31Z'/%3E%3Cpath class='cls-3' d='M112.28,19.92h10.38c5.39,0,8.79,3.15,8.79,8.36s-3.33,8.32-8.86,8.32h-4.96v8.65h-5.35V19.92Zm10.24,11.76c2.13,0,3.58-1.3,3.58-3.44,0-2.32-1.23-3.44-3.54-3.44h-4.92v6.87h4.88Z'/%3E%3Cpath class='cls-3' d='M146,41.3h-9.7l-1.34,3.94h-5.32l9.04-25.33h4.92l9.04,25.33h-5.32l-1.34-3.94Zm-1.63-4.7l-3.18-9.33h-.07l-3.18,9.33h6.44Z'/%3E%3C/g%3E%3Cg%3E%3Crect class='cls-2' x='26.34' y='19.12' width='27.5' height='27.5'/%3E%3Cg%3E%3Cpolygon class='cls-3' points='61.15 32.87 58.57 32.87 58.57 15.25 40.15 15.25 40.15 12.67 61.15 12.67 61.15 32.87'/%3E%3Cpolygon class='cls-3' points='40.15 53.07 19.04 53.07 19.04 32.87 21.62 32.87 21.62 50.49 40.15 50.49 40.15 53.07'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
					}
					&.AI {
						background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 428 65'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:none;%7D.cls-2%7Bfill:%23ec6568;%7D.cls-3%7Bfill:%23062b80;%7D%3C/style%3E%3C/defs%3E%3Crect class='cls-1' width='428' height='65'/%3E%3Cg%3E%3Cpath class='cls-3' d='M103.42,41.3h-9.7l-1.34,3.94h-5.32l9.04-25.33h4.92l9.04,25.33h-5.32l-1.34-3.94Zm-1.63-4.7l-3.18-9.33h-.07l-3.18,9.33h6.44Z'/%3E%3Cpath class='cls-3' d='M112.39,19.92h5.35v25.33h-5.35V19.92Z'/%3E%3C/g%3E%3Cg%3E%3Crect class='cls-2' x='19.91' y='12.29' width='17.19' height='17.19'/%3E%3Crect class='cls-2' x='43.72' y='36.11' width='17.19' height='17.19'/%3E%3Cpolygon class='cls-3' points='55.95 31.55 41.63 31.55 41.63 17.26 39.15 17.26 39.15 31.55 24.87 31.55 24.87 34.03 39.15 34.03 39.15 48.35 41.63 48.35 41.63 34.03 55.95 34.03 55.95 31.55'/%3E%3C/g%3E%3C/svg%3E");
					}
					&.Spark {
						background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 428 65'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:none;%7D.cls-2%7Bfill:%23ec6568;%7D.cls-3%7Bfill:%23062b80;%7D%3C/style%3E%3C/defs%3E%3Crect class='cls-1' width='428' height='65'/%3E%3Cg%3E%3Cpath class='cls-3' d='M103.42,41.3h-9.7l-1.34,3.94h-5.32l9.04-25.33h4.92l9.04,25.33h-5.32l-1.34-3.94Zm-1.63-4.7l-3.18-9.33h-.07l-3.18,9.33h6.44Z'/%3E%3Cpath class='cls-3' d='M112.39,19.92h5.35v25.33h-5.35V19.92Z'/%3E%3C/g%3E%3Cg%3E%3Crect class='cls-2' x='19.91' y='12.29' width='17.19' height='17.19'/%3E%3Crect class='cls-2' x='43.72' y='36.11' width='17.19' height='17.19'/%3E%3Cpolygon class='cls-3' points='55.95 31.55 41.63 31.55 41.63 17.26 39.15 17.26 39.15 31.55 24.87 31.55 24.87 34.03 39.15 34.03 39.15 48.35 41.63 48.35 41.63 34.03 55.95 34.03 55.95 31.55'/%3E%3C/g%3E%3C/svg%3E");
					}
					&.IDP {
						background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 631.86 64.79'%3E%3Cdefs%3E%3Cstyle%3E.b%7Bfill:none;%7D.c%7Bfill:%23cd3333;%7D%3C/style%3E%3C/defs%3E%3Crect class='b' width='631.86' height='64.79'/%3E%3Cpath d='M81.99,19.13h5.48v25.9h-5.48v-25.9Z'/%3E%3Cpath d='M91.16,25.42h5.03v1.74h.07c1.15-1.41,3.22-2.29,5.4-2.29,4.29,0,7.18,2.96,7.18,7.62v12.54h-5.29v-11.62c0-2.33-1.26-3.66-3.55-3.66s-3.55,1.41-3.55,3.66v11.62h-5.29v-19.61Z'/%3E%3Cpath d='M118.25,30.08v8.29c0,1.22.44,1.59,2,1.59h2.15v5.07h-2.67c-4.85,0-6.77-1.78-6.77-6.33v-8.62h-3.37v-4.66h3.37v-4.92h5.29v4.92h4.85v4.66h-4.85Z'/%3E%3Cpath d='M123.43,35.23c0-6.11,3.81-10.36,9.25-10.36s9.21,4.18,9.21,10.36v1.55h-13.14c.15,2.78,1.63,4.37,4.03,4.37,1.92,0,3.37-.92,4.74-2.92l3.74,2.92c-1.89,2.96-4.77,4.44-8.47,4.44-5.55,0-9.36-4.14-9.36-10.36ZM136.75,33.04c-.18-2.37-1.63-3.74-4.03-3.74-2.18,0-3.77,1.48-3.96,3.74h7.99Z'/%3E%3Cpath d='M144.07,18.02h5.29v27.01h-5.29v-27.01Z'/%3E%3Cpath d='M152.29,18.02h5.29v27.01h-5.29v-27.01Z'/%3E%3Cpath d='M160.43,17.02h5.37v5.18h-5.37v-5.18ZM160.5,25.42h5.29v19.61h-5.29v-19.61Z'/%3E%3Cpath d='M168.82,49.33l4-3c1.55,2.15,2.89,2.92,5,2.92,2.63,0,4.18-1.67,4.18-4.37v-1.44h-.07c-.96,1.26-3.07,2.11-5.22,2.11-5.11,0-8.77-4.33-8.77-10.36s3.7-10.14,8.77-10.14c2.18,0,4.03.67,5.22,1.92h.07v-1.55h5.11v19.65c0,5.44-3.63,8.84-9.32,8.84-3.74,0-7.07-1.74-8.96-4.59ZM181.81,36.6v-2.63c0-2.41-1.74-4.11-4.11-4.11-2.85,0-4.48,2-4.48,5.33s1.67,5.51,4.48,5.51c2.41,0,4.11-1.7,4.11-4.11Z'/%3E%3Cpath d='M189.06,35.23c0-6.11,3.81-10.36,9.25-10.36s9.21,4.18,9.21,10.36v1.55h-13.14c.15,2.78,1.63,4.37,4.03,4.37,1.92,0,3.37-.92,4.74-2.92l3.74,2.92c-1.89,2.96-4.77,4.44-8.47,4.44-5.55,0-9.36-4.14-9.36-10.36ZM202.38,33.04c-.18-2.37-1.63-3.74-4.03-3.74-2.18,0-3.77,1.48-3.96,3.74h7.99Z'/%3E%3Cpath d='M209.71,25.42h5.03v1.74h.07c1.15-1.41,3.22-2.29,5.4-2.29,4.29,0,7.18,2.96,7.18,7.62v12.54h-5.29v-11.62c0-2.33-1.26-3.66-3.55-3.66s-3.55,1.41-3.55,3.66v11.62h-5.29v-19.61Z'/%3E%3Cpath d='M236.79,30.08v8.29c0,1.22.44,1.59,2,1.59h2.15v5.07h-2.67c-4.85,0-6.77-1.78-6.77-6.33v-8.62h-3.37v-4.66h3.37v-4.92h5.29v4.92h4.85v4.66h-4.85Z'/%3E%3Cpath d='M252.85,19.13h8.99c6.88,0,11.36,4.88,11.36,12.95s-4.48,12.95-11.4,12.95h-8.96v-25.9ZM261.8,40c3.63,0,5.92-2.63,5.92-7.92s-2.29-7.92-5.92-7.92h-3.48v15.84h3.48Z'/%3E%3Cpath d='M274.57,35.23c0-6.18,3.96-10.36,9.69-10.36s9.73,4.18,9.73,10.36-3.96,10.36-9.73,10.36-9.69-4.18-9.69-10.36ZM288.7,35.23c0-3.52-1.63-5.55-4.44-5.55s-4.4,2.04-4.4,5.55,1.63,5.55,4.4,5.55,4.44-2.04,4.44-5.55Z'/%3E%3Cpath d='M295.4,35.23c0-6.18,3.96-10.36,9.51-10.36,4.77,0,8.14,2.81,8.84,7.25l-5,.89c-.41-2.15-1.74-3.33-3.85-3.33-2.59,0-4.22,2.04-4.22,5.55s1.63,5.55,4.22,5.55c2.18,0,3.48-1.18,3.85-3.33l5,.89c-.7,4.44-4.07,7.25-8.84,7.25-5.55,0-9.51-4.18-9.51-10.36Z'/%3E%3Cpath d='M315.42,38.34v-12.91h5.29v11.69c0,2.44,1.15,3.63,3.4,3.63,2.11,0,3.44-1.41,3.44-3.63v-11.69h5.29v19.61h-5.03v-1.74h-.07c-1.15,1.41-3.14,2.29-5.29,2.29-4.44,0-7.03-2.7-7.03-7.25Z'/%3E%3Cpath d='M335.8,25.42h4.88v1.74h.07c1.11-1.44,3.07-2.29,5.14-2.29,1.89,0,3.96.85,5.03,2.4h.07c1.29-1.52,3-2.4,5.25-2.4,4.44,0,7.25,3.29,7.25,7.18v12.99h-5.11v-11.99c0-2.15-1.26-3.37-3.15-3.37s-3.18,1.37-3.18,3.48v11.88h-4.88v-11.99c0-2.15-1.26-3.37-3.15-3.37s-3.15,1.37-3.15,3.48v11.88h-5.11v-19.61Z'/%3E%3Cpath d='M365.48,35.23c0-6.11,3.81-10.36,9.25-10.36s9.21,4.18,9.21,10.36v1.55h-13.14c.15,2.78,1.63,4.37,4.03,4.37,1.92,0,3.37-.92,4.74-2.92l3.74,2.92c-1.89,2.96-4.77,4.44-8.47,4.44-5.55,0-9.36-4.14-9.36-10.36ZM378.8,33.04c-.18-2.37-1.63-3.74-4.03-3.74-2.18,0-3.77,1.48-3.96,3.74h7.99Z'/%3E%3Cpath d='M386.12,25.42h5.03v1.74h.07c1.15-1.41,3.22-2.29,5.4-2.29,4.29,0,7.18,2.96,7.18,7.62v12.54h-5.29v-11.62c0-2.33-1.26-3.66-3.55-3.66s-3.55,1.41-3.55,3.66v11.62h-5.29v-19.61Z'/%3E%3Cpath d='M413.21,30.08v8.29c0,1.22.44,1.59,2,1.59h2.15v5.07h-2.67c-4.85,0-6.77-1.78-6.77-6.33v-8.62h-3.37v-4.66h3.37v-4.92h5.29v4.92h4.85v4.66h-4.85Z'/%3E%3Cpath d='M429.26,19.13h10.62c5.51,0,8.99,3.22,8.99,8.55s-3.4,8.51-9.07,8.51h-5.07v8.84h-5.48v-25.9ZM439.73,31.16c2.18,0,3.66-1.33,3.66-3.52,0-2.37-1.26-3.51-3.63-3.51h-5.03v7.03h5Z'/%3E%3Cpath d='M450.54,25.42h4.96v1.74h.07c.85-1.29,2.29-2.11,4.22-2.11.96,0,1.78.11,2.55.33l-.89,5.03c-.85-.22-1.48-.3-2.18-.3-2.26,0-3.44,1.52-3.44,4.37v10.55h-5.29v-19.61Z'/%3E%3Cpath d='M461.79,35.23c0-6.18,3.96-10.36,9.69-10.36s9.73,4.18,9.73,10.36-3.96,10.36-9.73,10.36-9.69-4.18-9.69-10.36ZM475.92,35.23c0-3.52-1.63-5.55-4.44-5.55s-4.4,2.04-4.4,5.55,1.63,5.55,4.4,5.55,4.44-2.04,4.44-5.55Z'/%3E%3Cpath d='M482.62,35.23c0-6.18,3.96-10.36,9.51-10.36,4.77,0,8.14,2.81,8.84,7.25l-5,.89c-.41-2.15-1.74-3.33-3.85-3.33-2.59,0-4.22,2.04-4.22,5.55s1.63,5.55,4.22,5.55c2.18,0,3.48-1.18,3.85-3.33l5,.89c-.7,4.44-4.07,7.25-8.84,7.25-5.55,0-9.51-4.18-9.51-10.36Z'/%3E%3Cpath d='M502.23,35.23c0-6.11,3.81-10.36,9.25-10.36s9.21,4.18,9.21,10.36v1.55h-13.14c.15,2.78,1.63,4.37,4.03,4.37,1.92,0,3.37-.92,4.74-2.92l3.74,2.92c-1.89,2.96-4.77,4.44-8.47,4.44-5.55,0-9.36-4.14-9.36-10.36ZM515.55,33.04c-.18-2.37-1.63-3.74-4.03-3.74-2.18,0-3.77,1.48-3.96,3.74h7.99Z'/%3E%3Cpath d='M521.36,38.71l4.7-1.26c.63,2.63,1.96,3.81,4.48,3.81,1.85,0,2.96-.59,2.96-1.59,0-1.55-1.92-2.11-4.25-2.85-3.33-.92-6.85-2.07-6.85-6.03,0-3.37,3.15-5.92,7.4-5.92,3.96,0,7.36,2.29,8.29,5.77l-4.66,1.37c-.67-1.92-1.96-2.85-3.63-2.85-1.55,0-2.48.67-2.48,1.55,0,1,1.48,1.41,3.52,2,3.4.96,7.59,2.22,7.59,6.77,0,3.66-3.11,6.11-7.88,6.11s-8.33-2.44-9.18-6.88Z'/%3E%3Cpath d='M538.75,38.71l4.7-1.26c.63,2.63,1.96,3.81,4.48,3.81,1.85,0,2.96-.59,2.96-1.59,0-1.55-1.92-2.11-4.25-2.85-3.33-.92-6.85-2.07-6.85-6.03,0-3.37,3.15-5.92,7.4-5.92,3.96,0,7.36,2.29,8.29,5.77l-4.66,1.37c-.67-1.92-1.96-2.85-3.63-2.85-1.55,0-2.48.67-2.48,1.55,0,1,1.48,1.41,3.52,2,3.4.96,7.59,2.22,7.59,6.77,0,3.66-3.11,6.11-7.88,6.11s-8.33-2.44-9.18-6.88Z'/%3E%3Cpath d='M557.54,17.02h5.37v5.18h-5.37v-5.18ZM557.62,25.42h5.29v19.61h-5.29v-19.61Z'/%3E%3Cpath d='M565.83,25.42h5.03v1.74h.07c1.15-1.41,3.22-2.29,5.4-2.29,4.29,0,7.18,2.96,7.18,7.62v12.54h-5.29v-11.62c0-2.33-1.26-3.66-3.55-3.66s-3.55,1.41-3.55,3.66v11.62h-5.29v-19.61Z'/%3E%3Cpath d='M586.4,49.33l4-3c1.55,2.15,2.89,2.92,5,2.92,2.63,0,4.18-1.67,4.18-4.37v-1.44h-.07c-.96,1.26-3.07,2.11-5.22,2.11-5.11,0-8.77-4.33-8.77-10.36s3.7-10.14,8.77-10.14c2.18,0,4.03.67,5.22,1.92h.07v-1.55h5.11v19.65c0,5.44-3.63,8.84-9.32,8.84-3.74,0-7.07-1.74-8.96-4.59ZM599.39,36.6v-2.63c0-2.41-1.74-4.11-4.11-4.11-2.85,0-4.48,2-4.48,5.33s1.67,5.51,4.48,5.51c2.41,0,4.11-1.7,4.11-4.11Z'/%3E%3Cpolygon points='20.15 29.19 20.16 29.2 20.83 28.68 20.15 29.19'/%3E%3Cpolygon points='20.15 29.2 20.16 29.2 20.16 29.2 20.15 29.2'/%3E%3Cpolygon points='60.45 34.99 60.45 35 60.45 34.99 60.45 34.99'/%3E%3Cpolygon points='20.83 28.68 21.2 28.41 21.2 28.41 21.17 28.43 20.83 28.68'/%3E%3Cpath class='c' d='M45.32,39.09v3.9c0,1.36-1.11,2.47-2.47,2.47h-14.52c-1.36,0-2.47-1.11-2.47-2.47v-21.19c0-1.36,1.11-2.47,2.47-2.47h14.52c.73,0,1.37.32,1.82.82.19-.69.49-1.61.85-1.83.18-.11.35-.21.52-.3-.87-.73-1.97-1.19-3.19-1.19h-14.52c-2.74,0-4.97,2.23-4.97,4.97v21.19c0,2.74,2.23,4.97,4.97,4.97h14.52c2.74,0,4.97-2.23,4.97-4.97v-2.79c-.49-.06-1.08-.16-1.51-.38-.41-.21-.74-.47-.99-.73Z'/%3E%3Cpath class='c' d='M57.05,29.24c0-.13,0-.27,0-.4s0-.26,0-.4l1.08-.98c.38-.34.61-.79.67-1.27l.19-.17-.3-.81c-.17-.47-.39-.94-.65-1.42l-.18-.3c-.26-.44-.56-.86-.9-1.27-.53-.64-1.4-.89-2.21-.64l-1.39.44c-.22-.14-.45-.28-.69-.4l-.31-1.43c-.18-.84-.84-1.46-1.66-1.6-1.14-.19-2.34-.19-3.43,0-.83.14-1.48.76-1.67,1.6l-.31,1.43c-.24.12-.47.25-.69.4l-1.39-.44c-.81-.26-1.69,0-2.22.64-.33.4-.63.83-.9,1.28l-.18.31c-.25.45-.46.92-.64,1.4-.29.79-.07,1.67.56,2.23l1.08.98c0,.13,0,.27,0,.4s0,.27.01.4l-1.08.98c-.63.57-.86,1.45-.57,2.24.17.47.39.94.65,1.42l.18.3c.26.44.56.86.9,1.27.54.64,1.4.89,2.21.63l1.39-.44c.22.14.45.28.69.4l.31,1.43c.18.83.84,1.46,1.66,1.6.57.09,1.14.14,1.72.14s1.15-.05,1.72-.14c.83-.14,1.48-.76,1.67-1.6l.31-1.43c.24-.12.47-.25.69-.4l1.39.44c.82.26,1.69,0,2.22-.64.33-.4.63-.83.91-1.28l.18-.31c.25-.45.47-.92.64-1.4.29-.79.07-1.67-.56-2.23l-1.08-.98ZM54.51,28.11c.03.24.05.49.05.74s-.02.5-.05.74l-.09.65,1.81,1.65c-.11.26-.23.51-.36.74l-.16.27c-.15.24-.31.48-.49.72l-2.33-.74-.52.4c-.4.3-.83.55-1.28.74l-.61.25-.52,2.38c-.66.08-1.34.08-2,0l-.52-2.38-.61-.25c-.45-.19-.88-.44-1.28-.74l-.52-.4-2.32.74c-.18-.23-.34-.47-.48-.7l-.15-.26c-.14-.25-.26-.51-.37-.76l1.81-1.65-.08-.65c-.03-.25-.05-.49-.05-.75s.02-.5.05-.74l.09-.65-1.81-1.65c.11-.26.23-.51.36-.74l.16-.28c.15-.24.31-.48.49-.71l2.33.74.52-.4c.39-.3.82-.55,1.28-.74l.61-.25.52-2.39c.65-.08,1.33-.09,2.01,0l.52,2.38.61.25c.46.19.89.44,1.28.74l.52.4,2.33-.74c.18.23.34.47.48.7l.15.26c.14.25.26.51.37.76l-1.81,1.65.09.65Z'/%3E%3Cpath class='c' d='M48.98,27.25c-.57,0-1.1.31-1.38.8s-.28,1.1,0,1.6c.28.49.81.8,1.38.8s1.1-.31,1.38-.8.28-1.1,0-1.6c-.28-.49-.81-.8-1.38-.8Z'/%3E%3Cpath class='c' d='M36.12,22.87h-6.65c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25h6.65c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25Z'/%3E%3Cpath class='c' d='M29.47,30.15h6.65c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25h-6.65c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25Z'/%3E%3Cpath class='c' d='M29.47,34.94h6.65c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25h-6.65c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25Z'/%3E%3Cpath class='c' d='M29.47,39.73h11.77c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25h-11.77c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25Z'/%3E%3C/svg%3E");
					}
				}
			}
		}
		&:hover {
			.netcallIcon {
				background-color: rgba(white, 0.1);
				transition: all ease-in-out .2s;
			}
			.netcallDropdown {
				display: block;
			}
		}
	}

.nav-section-top {
	.navigation-item {
		display: block;
		height: 30px;
		width: 30px;
		border-left: 0;
		span {
			height: 30px;
			width: 30px;
			border-left: 0;
			background-repeat: no-repeat;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		&:hover:after {
			display: block;
			content: '';
			height: 50px;
			width: 50px;
			margin-right: -40px;
			position: absolute;
		}

		&.create span {
			background-image: url("/images/Create_Icon_White.svg");
		}
		&.RPA span {
			background-image: url("/images/RPA_Icon_White.svg");
		}
		&.AI span {
			background-image: url("/images/AI_Icon_White.svg");
		}
		&.Spark span {
			background-image: url("/images/AI_Icon_White.svg");
		}
	}
}

	@media screen and (max-height: 640px) {
		.partial-sidebar {
			.logo-container {
				&:not(.minified-sidebar) {
					position: fixed;
					z-index: 1000;
					width: $sidebar-width-inactive;
					background-color: $primary-colour;
				}
			}
			.navigation.minified-sidebar {
				padding-top: 0;
				padding-top: 0;
				width: 100%;
				padding-top: 50px;
				/* overflow-y: scroll;
				scrollbar-gutter: stable; */
				.navigation-item {
					padding: 2vh 0;
					padding-left: 10px;
				}
				&::-webkit-scrollbar {
					width: 5px;
				}
				&::-webkit-scrollbar-track {
					background-color: transparent;
					width: 5px;
					border-radius: 8px;
				}
				&::-webkit-scrollbar-thumb {
					background-color: #1b2632;
					border-radius: 10px;
				}
				&:hover {
					scrollbar-color: #334867 transparent;
					&::-webkit-scrollbar {
						width: 5px;
					}
					&::-webkit-scrollbar-track {
						background-color: #1b2632;
						border-radius: 8px;
					}
					&::-webkit-scrollbar-thumb {
						background-color: rgba(206, 206, 206, 0.3);
					}
				}
				.nav-section-bottom {
					position: initial;
					bottom: 0;
					margin-top: 1rem;
				}
			}
			.navigation {
				&:not(.minified-sidebar) {
					width: 100%;
					padding-top: 50px;
					/* overflow-y: scroll;
					scrollbar-gutter: stable; */
					&::-webkit-scrollbar {
						width: 5px;
					}
					&::-webkit-scrollbar-track {
						background-color: transparent;
						width: 5px;
						border-radius: 8px;
					}
					&::-webkit-scrollbar-thumb {
						background-color: #1b2632;
						border-radius: 10px;
					}
					&:hover {
						scrollbar-color: #334867 transparent;
						&::-webkit-scrollbar {
							width: 5px;
						}
						&::-webkit-scrollbar-track {
							background-color: #1b2632;
							border-radius: 8px;
						}
						&::-webkit-scrollbar-thumb {
							background-color: rgba(206, 206, 206, 0.3);
						}
					}
					.nav-section-bottom {
						position: initial;
						bottom: 0;
						margin-top: 1rem;
					}
				}
			}
		}
	}

	@media screen and (min-width: 500px) and (max-height: 640px) {
		aside#sidebar.minified-sidebar {
			.partial-sidebar {
				.logo-container.minified-sidebar {
					position: fixed;
					z-index: 1000;
					width: $sidebar-width-inactive;
					background-color: $primary-colour;

				}
			}
		}
	}

	/* NEW NAVIGATION */

	.partial-sidebar {
		.navigation.minified-sidebar {
			.navigation-item {
				padding: 0;
				padding-left: 0;
				display: flex;
				justify-content: center;
				&:not(.nav-header) {
					margin-bottom: 1rem;
					&:hover {
						background: none;
					}
				}
			}
		}
		.nav-section-top {
			.navigation-item {
				display: block;
				border-left: 0 !important;
				&:hover {
					background: none;
				}
				span {
					height: 30px;
					width: 30px;
					border-left: 0;
					border-radius: 5px;
					background-repeat: no-repeat;
					transition: 0.5s background-color ease-in-out;
					background-size: 85%;
					background-position: center center;
					&:hover {
						background-color: rgba(255, 255, 255, 0.1);
						transition: 0.3s background-color ease-in-out;
					}
				}

				&.Create span {
					background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 120'%3E%3Cdefs%3E%3Cstyle%3E.b%7Bfill:none;%7D.b,.c%7Bstroke-width:0px;%7D.d%7Bopacity:.8;%7D.c%7Bfill:%23fff;%7D%3C/style%3E%3C/defs%3E%3Cg class='d'%3E%3Cpath class='c' d='m95.72,79.64h-6.88v-6.88c0-1.62-1.31-2.93-2.93-2.93s-2.93,1.31-2.93,2.93v6.88h-6.88c-1.62,0-2.93,1.31-2.93,2.93s1.31,2.93,2.93,2.93h6.88v6.88c0,1.62,1.31,2.93,2.93,2.93s2.93-1.31,2.93-2.93v-6.88h6.88c1.62,0,2.93-1.31,2.93-2.93s-1.31-2.93-2.93-2.93Z'/%3E%3Cpath class='c' d='m88.26,23.79H31.74c-6.24,0-11.32,5.08-11.32,11.32v49.78c0,6.24,5.08,11.32,11.32,11.32h31.19v-33.28h36.65v-27.82c0-6.24-5.08-11.32-11.32-11.32Zm-31.19,66.81h-25.33c-3.14,0-5.7-2.56-5.7-5.7v-21.96h31.02v27.66Zm0-33.52h-31.02v-21.96c0-3.14,2.55-5.7,5.7-5.7h25.33v27.66Zm36.89,0h-31.03v-27.66h25.33c3.14,0,5.7,2.55,5.7,5.7v21.96Z'/%3E%3C/g%3E%3Crect class='b' width='120' height='120'/%3E%3C/svg%3E");
				}
				&.Converse span {
					background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 120'%3E%3Cdefs%3E%3Cstyle%3E.b%7Bfill:none;%7D.b,.c%7Bstroke-width:0px;%7D.d%7Bopacity:.8;%7D.c%7Bfill:%23fff;%7D%3C/style%3E%3C/defs%3E%3Cg class='d'%3E%3Cpath class='c' d='m58.47,46.65c-.14-.28-.21-.49-.28-.7-.09-.26-.17-.52-.35-.87l-.11-.15c-.06-.06-.11-.15-.18-.26-.31-.47-.84-1.26-2.13-2.04l-.03-.13-.26-.17c-.95-.63-2.31-1.04-3.47-1.04-4.07,0-7.51,3.44-7.51,7.51s3.44,7.5,7.51,7.5c.3,0,.55-.05.76-.12-1.05,3.47-3.41,6.2-7.01,8.14l-.14.1c-.74.74-1.11,1.52-1.11,2.3,0,1.59,1.2,2.79,2.79,2.79.33,0,.82,0,1.28-.42,7.15-3.61,11.25-10.09,11.25-17.88-.08-.5-.14-.95-.2-1.37-.16-1.17-.29-2.19-.8-3.2Z'/%3E%3Cpath class='c' d='m75.49,45.94c-.09-.26-.17-.52-.35-.87l-.11-.15c-.06-.06-.11-.15-.18-.26-.31-.47-.84-1.26-2.13-2.04l-.03-.13-.26-.17c-.95-.63-2.31-1.04-3.47-1.04-4.07,0-7.51,3.44-7.51,7.51s3.44,7.5,7.51,7.5c.3,0,.55-.05.76-.12-1.05,3.47-3.41,6.2-6.99,8.13-.58.29-1.27.94-1.27,2.41,0,1.59,1.2,2.79,2.79,2.79.33,0,.82,0,1.28-.42,7.15-3.61,11.25-10.08,11.25-17.78,0-1.89-.29-3.24-1-4.66-.14-.28-.21-.49-.28-.7Z'/%3E%3Cpath class='c' d='m35.46,101.17c-.4,0-.8-.08-1.18-.26-1-.46-1.63-1.46-1.63-2.55v-7.11h-.9c-6.24,0-11.32-5.08-11.32-11.32V30.15c0-6.24,5.08-11.32,11.32-11.32h56.52c6.24,0,11.32,5.08,11.32,11.32v49.78c0,6.24-5.08,11.32-11.32,11.32h-40.09l-10.89,9.26c-.52.44-1.17.67-1.82.67Zm-3.71-76.73c-3.14,0-5.7,2.56-5.7,5.7v49.78c0,3.14,2.55,5.7,5.7,5.7h3.71c1.55,0,2.81,1.26,2.81,2.81v3.85l7.05-5.99c.51-.43,1.16-.67,1.82-.67h41.12c3.14,0,5.7-2.56,5.7-5.7V30.15c0-3.14-2.55-5.7-5.7-5.7H31.74Z'/%3E%3C/g%3E%3Crect class='b' width='120' height='120'/%3E%3C/svg%3E");
				}
				&.Spark span {
					background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 119.06 119.06'%3E%3Cdefs%3E%3Cstyle%3E.b%7Bfill:none;%7D.b,.c%7Bstroke-width:0px;%7D.c%7Bfill:%23fff;opacity:.8;%7D%3C/style%3E%3C/defs%3E%3Crect class='b' width='119.06' height='119.06'/%3E%3Cpath class='c' d='m96.28,52.38c1.57,0,2.84-1.27,2.84-2.82v-15.33c0-5.98-4.89-10.84-10.9-10.84h-23.46l-6.44-6.44c-1.1-1.1-2.88-1.1-3.98,0-1.1,1.09-1.1,2.88,0,3.97l2.47,2.47h-25.97c-6.01,0-10.9,4.86-10.9,10.84v18.12c0,5.98,4.89,10.84,10.9,10.84h15v3.3c0,3.54,2.88,6.41,6.42,6.41h15.38c3.54,0,6.42-2.87,6.42-6.41v-3.3h14.16c2.88,0,5.22,2.33,5.22,5.19v16.48c0,2.86-2.34,5.19-5.22,5.19h-23.49l-6.41-6.41c-1.1-1.1-2.88-1.1-3.98,0-1.1,1.09-1.1,2.88,0,3.97l2.43,2.43h-25.93c-2.88,0-5.22-2.33-5.22-5.19v-14.53c0-1.56-1.27-2.82-2.84-2.82s-2.84,1.26-2.84,2.82v14.53c0,5.97,4.89,10.84,10.9,10.84h25.93l-2.43,2.44c-1.1,1.09-1.1,2.88,0,3.97.55.55,1.27.82,1.99.82s1.44-.27,1.99-.82l6.41-6.41h23.49c6.01,0,10.9-4.86,10.9-10.84v-16.48c0-5.97-4.89-10.84-10.9-10.84h-14.16v-3.56c0-3.54-2.88-6.41-6.42-6.41h-15.38c-3.54,0-6.42,2.87-6.42,6.41v3.56h-15c-2.88,0-5.22-2.33-5.22-5.19v-18.12c0-2.87,2.34-5.2,5.22-5.2h25.9l-2.4,2.4c-1.1,1.09-1.1,2.88,0,3.97.55.55,1.27.82,1.99.82s1.44-.27,1.99-.82l6.38-6.38h23.52c2.88,0,5.22,2.33,5.22,5.2v15.33c0,1.56,1.27,2.82,2.84,2.82Zm-44.81,10.81v-9.21c0-.43.35-.79.79-.79h15.38c.43,0,.79.36.79.79v12.5c0,.43-.35.79-.79.79h-15.38c-.43,0-.79-.36-.79-.79v-3.3Z'/%3E%3C/svg%3E");
				}
				&.RPA span {
					background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 120'%3E%3Cdefs%3E%3Cstyle%3E.b%7Bfill:none;%7D.b,.c%7Bstroke-width:0px;%7D.d%7Bopacity:.8;%7D.c%7Bfill:%23fff;%7D%3C/style%3E%3C/defs%3E%3Crect class='b' width='120' height='120'/%3E%3Cg class='d'%3E%3Cpath class='c' d='m99.58,49.44v-5.32c0-6.24-5.08-11.32-11.32-11.32h-25.56v-5.06c3.48-1.14,6.02-4.39,6.02-8.25,0-4.81-3.91-8.72-8.72-8.72s-8.71,3.91-8.71,8.72c0,3.86,2.54,7.1,6.02,8.25v5.06h-25.56c-6.24,0-11.32,5.08-11.32,11.32v5.32c-4.86.52-8.67,4.6-8.67,9.6v16.47c0,5,3.81,9.07,8.67,9.6v8.8c0,6.24,5.08,11.32,11.32,11.32h56.52c6.24,0,11.32-5.08,11.32-11.32v-8.8c4.86-.52,8.67-4.6,8.67-9.6v-16.47c0-5-3.81-9.07-8.67-9.6ZM60,16.17c1.83,0,3.32,1.49,3.32,3.32s-1.49,3.32-3.32,3.32-3.32-1.49-3.32-3.32,1.49-3.32,3.32-3.32Zm-43.1,59.34v-16.47c0-2.14,1.52-3.86,3.52-4.34v25.14c-2-.48-3.52-2.2-3.52-4.34Zm77.05,18.39c0,3.14-2.55,5.7-5.7,5.7H31.74c-3.14,0-5.7-2.56-5.7-5.7v-49.78c0-3.14,2.55-5.7,5.7-5.7h56.52c3.14,0,5.7,2.56,5.7,5.7v49.78Zm9.14-18.39c0,2.14-1.52,3.86-3.52,4.34v-25.14c2,.48,3.52,2.2,3.52,4.34v16.47Z'/%3E%3Cpath class='c' d='m56.87,59.48c0-5.09-4.15-9.24-9.24-9.24s-9.24,4.15-9.24,9.24,4.15,9.24,9.24,9.24c5.09,0,9.24-4.15,9.24-9.24Zm-12.83,0c0-1.98,1.61-3.59,3.59-3.59s3.59,1.61,3.59,3.59-1.61,3.58-3.59,3.58-3.59-1.61-3.59-3.58Z'/%3E%3Cpath class='c' d='m73.17,50.23c-5.09,0-9.24,4.15-9.24,9.24s4.15,9.24,9.24,9.24,9.24-4.14,9.24-9.24-4.15-9.24-9.24-9.24Zm0,12.83c-1.98,0-3.59-1.61-3.59-3.58s1.61-3.59,3.59-3.59,3.59,1.61,3.59,3.59-1.61,3.58-3.59,3.58Z'/%3E%3Cpath class='c' d='m75.36,77.86c-.76,0-1.47.32-2,.86l-.04.05c-3.47,3.57-7.94,5.46-12.9,5.48-4.81-.02-9.33-1.97-12.71-5.51-.52-.55-1.22-.86-1.97-.87h-.03c-.83.05-1.5.32-1.99.78-.54.52-.85,1.22-.87,1.97-.02.76.26,1.47.78,2.02,4.45,4.66,10.44,7.23,16.86,7.26,6.38,0,12.39-2.57,16.94-7.25,1.08-1.12,1.05-2.91-.06-3.99-.53-.52-1.23-.81-2-.81Z'/%3E%3C/g%3E%3C/svg%3E");
				}
				&.AI span {
					background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 120'%3E%3Cdefs%3E%3Cstyle%3E.b%7Bfill:none;%7D.b,.c%7Bstroke-width:0px;%7D.d%7Bopacity:.8;%7D.c%7Bfill:%23fff;%7D%3C/style%3E%3C/defs%3E%3Crect class='b' width='120' height='120'/%3E%3Cg class='d'%3E%3Cpath class='c' d='m105.67,55.89c1.55,0,2.81-1.26,2.81-2.81s-1.26-2.81-2.81-2.81h-6.09v-8.22h6.09c1.55,0,2.81-1.26,2.81-2.81s-1.26-2.81-2.81-2.81h-6.09v-1.33c0-6.24-5.08-11.32-11.32-11.32h-4.69v-7.15c0-1.55-1.26-2.81-2.81-2.81s-2.81,1.26-2.81,2.81v7.15h-8.21v-7.15c0-1.55-1.26-2.81-2.81-2.81s-2.81,1.26-2.81,2.81v7.15h-8.21v-7.15c0-1.55-1.26-2.81-2.81-2.81s-2.81,1.26-2.81,2.81v7.15h-8.21v-7.15c0-1.55-1.26-2.81-2.81-2.81s-2.81,1.26-2.81,2.81v7.15h-4.69c-6.24,0-11.32,5.08-11.32,11.32v1.33h-6.09c-1.55,0-2.81,1.26-2.81,2.81s1.26,2.81,2.81,2.81h6.09v8.22h-6.09c-1.55,0-2.81,1.26-2.81,2.81s1.26,2.81,2.81,2.81h6.09v8.21h-6.09c-1.55,0-2.81,1.26-2.81,2.81s1.26,2.81,2.81,2.81h6.09v8.22h-6.09c-1.55,0-2.81,1.26-2.81,2.81s1.26,2.81,2.81,2.81h6.09v1.32c0,6.24,5.08,11.32,11.32,11.32h4.69v7.16c0,1.55,1.26,2.81,2.81,2.81s2.81-1.26,2.81-2.81v-7.16h8.21v7.16c0,1.55,1.26,2.81,2.81,2.81s2.81-1.26,2.81-2.81v-7.16h8.21v7.16c0,1.55,1.26,2.81,2.81,2.81s2.81-1.26,2.81-2.81v-7.16h8.21v7.16c0,1.55,1.26,2.81,2.81,2.81s2.81-1.26,2.81-2.81v-7.16h4.69c6.24,0,11.32-5.08,11.32-11.32v-1.32h6.09c1.55,0,2.81-1.26,2.81-2.81s-1.26-2.81-2.81-2.81h-6.09v-8.22h6.09c1.55,0,2.81-1.26,2.81-2.81s-1.26-2.81-2.81-2.81h-6.09v-8.21h6.09Zm-11.72,28.99c0,3.14-2.55,5.7-5.7,5.7H31.74c-3.14,0-5.7-2.56-5.7-5.7v-49.78c0-3.14,2.55-5.7,5.7-5.7h56.52c3.14,0,5.7,2.56,5.7,5.7v49.78Z'/%3E%3Cpath class='c' d='m56.41,46.46c-.38-.95-1.35-1.56-2.49-1.56s-2.11.61-2.49,1.56l-10.04,25.09c-.27.66-.25,1.39.03,2.05.28.66.8,1.16,1.46,1.43.66.26,1.38.25,2.05-.03.66-.28,1.17-.8,1.43-1.46l2.34-5.85h10.42l2.34,5.84c.41,1.03,1.38,1.68,2.48,1.68.34,0,.67-.06,1-.19.67-.27,1.19-.78,1.47-1.44.28-.65.29-1.38.02-2.04l-10.03-25.09Zm-5.56,15.88l3.07-7.67,3.07,7.67h-6.14Z'/%3E%3Cpath class='c' d='m73.98,44.78c-1.48,0-2.68,1.2-2.68,2.68v25.09c0,1.47,1.2,2.67,2.68,2.67s2.68-1.2,2.68-2.67v-25.09c0-1.48-1.2-2.68-2.68-2.68Z'/%3E%3C/g%3E%3C/svg%3E");
				}
				&.IDP span {
					background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 120'%3E%3Cdefs%3E%3Cstyle%3E.b%7Bfill:none;%7D.c%7Bfill:%23fff;%7D%3C/style%3E%3C/defs%3E%3Cpath class='c' d='M100.95,55.09l-2.6-2.37v-.12c.02-.29.03-.59.03-.91,0-.29,0-.59-.03-.92v-.12s.08-.08.08-.08l2.5-2.27c1.4-1.25,1.89-3.19,1.25-4.93-.41-1.1-.9-2.16-1.5-3.25l-.41-.69c-.6-1-1.29-1.98-2.06-2.91-1.18-1.42-3.1-1.97-4.87-1.39l-3.34,1.07-.1-.06c-.5-.32-1.03-.63-1.58-.91l-.1-.05-.75-3.43c-.4-1.84-1.84-3.22-3.66-3.52-2.59-.43-5.39-.43-7.9,0-1.83.3-3.27,1.68-3.67,3.52l-.75,3.43-.11.05c-.53.27-1.06.58-1.58.91l-.1.06-3.34-1.06c-1.79-.57-3.71-.02-4.88,1.4-.76.93-1.46,1.91-2.07,2.94l-.42.72c-.57,1.04-1.07,2.12-1.47,3.21-.64,1.74-.15,3.66,1.24,4.91l2.6,2.37v.12c-.02.3-.03.6-.03.91,0,.29,0,.6.03.92v.12s-.08.08-.08.08l-2.5,2.27c-1.4,1.25-1.88,3.19-1.25,4.93.41,1.09.9,2.16,1.5,3.25l.41.69c.6,1.01,1.3,1.99,2.06,2.91,1.18,1.42,3.09,1.97,4.87,1.4l3.34-1.07.1.06c.49.32,1.02.62,1.58.91l.1.06v.06s.75,3.38.75,3.38c.41,1.84,1.84,3.22,3.66,3.52,2.65.44,5.43.42,7.9,0,1.83-.3,3.27-1.68,3.67-3.52l.75-3.43.1-.05c.53-.27,1.06-.58,1.58-.91l.1-.06,3.35,1.06c1.8.58,3.71.03,4.88-1.4.76-.92,1.46-1.91,2.07-2.94l.42-.72c.57-1.03,1.07-2.11,1.48-3.21.64-1.74.15-3.66-1.24-4.91ZM92.96,49.92c.08.6.12,1.19.12,1.76s-.04,1.16-.12,1.75l-.18,1.38,4.24,3.85-.07.16c-.25.6-.53,1.18-.84,1.74l-.37.64c-.34.57-.73,1.14-1.14,1.69l-.11.14-5.45-1.73-1.1.85c-.93.71-1.95,1.3-3.03,1.75l-1.29.53-1.22,5.59-.17.02c-.77.1-1.57.15-2.36.15h-.13c-.75,0-1.51-.06-2.24-.15l-.18-.02-.04-.17-1.19-5.41-1.29-.53c-1.08-.44-2.1-1.03-3.03-1.75l-1.1-.85-5.44,1.74-.11-.14c-.42-.55-.79-1.1-1.13-1.65l-.36-.62c-.33-.61-.63-1.21-.88-1.8l-.07-.16,4.23-3.85-.18-1.37c-.08-.59-.12-1.18-.12-1.76s.04-1.17.12-1.75l.18-1.38-4.24-3.85.07-.16c.25-.59.53-1.17.84-1.74l.37-.65c.35-.57.73-1.14,1.14-1.69l.11-.14.08.03,5.37,1.71,1.1-.85c.93-.72,1.95-1.3,3.03-1.75l1.29-.53,1.22-5.59.17-.02c.77-.1,1.56-.15,2.36-.15h.13c.75,0,1.5.06,2.24.15l.18.02.04.17,1.19,5.41,1.29.53c1.08.44,2.1,1.03,3.03,1.75l1.1.85,5.44-1.74.11.14c.42.55.79,1.1,1.12,1.65l.36.62c.33.6.62,1.2.88,1.8l.07.16-4.23,3.85.18,1.37Z'/%3E%3Cpath class='c' d='M34.54,65.6h15.44c1.46,0,2.65-1.19,2.65-2.65s-1.19-2.65-2.65-2.65h-15.44c-1.46,0-2.65,1.19-2.65,2.65s1.19,2.65,2.65,2.65Z'/%3E%3Cpath class='c' d='M71.39,75.49v9.36c0,3.16-2.57,5.73-5.73,5.73H31.77c-3.16,0-5.73-2.57-5.73-5.73v-49.72c0-3.16,2.57-5.73,5.73-5.73h33.9c1.69,0,3.19.75,4.24,1.91.43-1.61,1.08-3.52,1.91-4.05.42-.27.82-.48,1.21-.69-2.01-1.7-4.58-2.77-7.41-2.77H31.9c-6.36,0-11.53,5.17-11.53,11.53v49.21c0,6.36,5.17,11.53,11.53,11.53h33.72c6.36,0,11.53-5.17,11.53-11.53v-6.47c-1.14-.13-2.52-.38-3.5-.88-.96-.49-1.66-1.09-2.25-1.7Z'/%3E%3Cpath class='c' d='M80.27,48.25c-.09-.01-.17-.02-.26-.02h-.16c-1.23,0-2.38.66-3,1.73-.31.53-.46,1.13-.46,1.73s.15,1.2.46,1.73c.6,1.04,1.72,1.7,2.92,1.73h.08c1.24,0,2.38-.67,3-1.73.31-.53.46-1.13.46-1.73s-.15-1.2-.46-1.73c-.54-.94-1.51-1.57-2.58-1.7Z'/%3E%3Cpath class='c' d='M49.97,37.96h-15.44c-1.46,0-2.65,1.19-2.65,2.65s1.19,2.65,2.65,2.65h15.44c1.46,0,2.65-1.19,2.65-2.65s-1.19-2.65-2.65-2.65Z'/%3E%3Cpath class='c' d='M34.54,54.39h15.44c1.46,0,2.65-1.19,2.65-2.65s-1.19-2.65-2.65-2.65h-15.44c-1.46,0-2.65,1.19-2.65,2.65s1.19,2.65,2.65,2.65Z'/%3E%3Cpath class='c' d='M34.54,76.72h27.33c1.46,0,2.65-1.19,2.65-2.65s-1.19-2.65-2.65-2.65h-27.33c-1.46,0-2.65,1.19-2.65,2.65s1.19,2.65,2.65,2.65Z'/%3E%3Crect class='b' width='120' height='120'/%3E%3C/svg%3E");
				}
			}
		}
	}

	.nav-section-bottom .navigation-item span {
			width: 30px;
			height: 30px;
			display: flex;
			justify-content: center;
			align-items: center;
			border-radius: 5px;
		transition: 0.5s background-color ease-in-out;
	}

	.nav-section-bottom .navigation-item:hover span {
			background-color: rgba(255, 255, 255, 0.1);
		transition: 0.3s background-color ease-in-out;
	}

	.nav-section-bottom .navigation-item {
			margin-bottom: 1rem;
	}

	.modal-content .rpaModal {
		display: grid;
		grid-template-columns: 4fr 3fr;
		gap: 2rem;
		margin-bottom: 1rem;
		p {
			font-size: 16px;
			line-height: 1.5;
			margin-bottom: 1rem;
		}
		.RobotIllustration {
			margin-top: -10px;
		}
	}
</style>
